export interface GuideCallout {
  label: string
  text: string
  href?: string
}

export interface GuideStep {
  id: string
  number: string
  title: string
  body: string
  callout?: GuideCallout
  note?: string
  image: string
  imageAlt: string
}

export const guideSteps: GuideStep[] = [
  {
    id: 'opret-konto',
    number: '01',
    title: 'Opret konto',
    body: 'Gå til Flex Funding via linket herunder og opret din investeringskonto. Indtast din e-mailadresse og vælg en sikker adgangskode for at komme i gang.',
    callout: {
      label: 'Brug dette link',
      text: 'https://portal.flexfunding.com/signup?partner=almenr',
      href: 'https://portal.flexfunding.com/signup?partner=almenr',
    },
    note: 'Vigtigt: kun konti oprettet via linket med “partner=almenr” får adgang til Almenrs investeringer.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f6c0e446-523f-4722-ad58-04a933306ac3.jpg',
    imageAlt:
      'Flex Fundings oprettelsesside med formularen “Bliv kunde” til navn, e-mail og adgangskode.',
  },
  {
    id: 'bekraeft-email',
    number: '02',
    title: 'Bekræft e-mail',
    body: 'Flex Funding sender en bekræftelseskode til den e-mailadresse, du har oprettet kontoen med. Indtast koden på platformen for at bekræfte din adresse.',
    callout: {
      label: 'Derfor',
      text: 'Du bliver bedt om at vælge kontotype: privat eller erhverv. De fleste vælger privat.',
    },
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/1a252e08-bccf-4622-9c21-aa7377e23352.jpg',
    imageAlt:
      'Dialogen “Bekræftelse af e-mail” med felt til bekræftelseskoden oven på investorportalen.',
  },
  {
    id: 'mitid',
    number: '03',
    title: 'Verificér med MitID',
    body: 'Log ind med MitID for at bekræfte, hvem du er. Det er lovpligtigt og sikrer, at kun du har adgang til din investeringskonto.',
    note: 'Tager 5 minutter. Har du ikke MitID, kan du vælge manuel verifikation.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/70cad32d-e9bd-47fc-a09d-fb914f82c376.jpg',
    imageAlt:
      'Dialogen “Bekræft dine oplysninger” med knappen til at gennemføre verifikation med MitID.',
  },
  {
    id: 'kyc-aml',
    number: '04',
    title: 'Gennemfør KYC og AML',
    body: 'Besvar en række spørgsmål om din investeringserfaring og dine midlers oprindelse. Denne godkendelse er et lovkrav, før du kan investere.',
    note: 'Godt at vide: oplysningerne behandles fortroligt og bruges kun til godkendelsen.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2d22a1e7-4a69-492f-8f00-2eb92005509f.jpg',
    imageAlt:
      'Panelet “Om dig” med spørgsmål om investeringserfaring og midlernes oprindelse.',
  },
  {
    id: 'indbetal',
    number: '05',
    title: 'Indbetal midler',
    body: 'Overfør det beløb, du ønsker at investere, til din investorkonto via straks eller almindelig bankoverførsel. Pengene står klar, så snart overførslen er registreret.',
    note: 'Straksoverførsel er typisk fremme med det samme. Almindelig overførsel tager 1 bankdag.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c468ab84-6baa-441f-813a-7c5d65b8e3b6.jpg',
    imageAlt:
      'Skærmen “Indbetal på din konto” med kontooplysninger og felt til beløb.',
  },
  {
    id: 'invester',
    number: '06',
    title: 'Invester på markedspladsen',
    body: 'Gå til Primær markedsplads, find Almenrs lån og tryk “Køb”. Her ser du løbetid, rente, risiko og hvor meget der er tilgængeligt.',
    note: 'Minimum 500 kr. Du kan investere ad flere omgange, indtil lånet er fuldt finansieret.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/fcdc632b-a8f4-4512-952a-1147eadf3aff.jpg',
    imageAlt:
      'Markedspladsen med et lån åbnet og investeringspanelet “Invester i lån” i siden.',
  },
]
